query DateCalcWeek3DayTotals(
  $endDate: Date!
  $rate: BigFloat!
  $startDate: Date!
) {
  dateCalcWeek3DayTotals(
    endDate: $endDate
    rate: $rate
    startDate: $startDate
  ) {
    dayRate
    dayTotal
    endDate
    extendedTotal
    fullPeriods
    partialPeriodDays
    periodNo
    periodRate
    periodTotal
    startDate
  }
}
